module.exports = __webpack_public_path__ + "static/media/_SendToAdvisorModal.b7448d07.scss";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Cob/views/SendToAdvisorModal/_SendToAdvisorModal.scss
// module id = 567
// module chunks = 0